<template>
  <div>
    <v-sheet class="py-3 py-md-6" color="primary">
      <TitleWidget dark>
        {{ item.title || title }}
      </TitleWidget>
    </v-sheet>

    <LoadingWidget v-if="loading" />

    <v-container v-else class="pb-10 pb-md-13 pb-lg-16 item">
      <v-row justify="center" no-gutters>
        <v-col cols="12" md="9">
          <img
            v-if="item.img"
            @error="onError"
            class="d-block mt-6"
            loading="lazy"
            :src="files + item.img + '?resize=1&w=' + (xsOnly ? 600 : 1200)"
            :alt="item.title"
            width="100%"
          />

          <div v-if="item.research > 1" class="d-flex justify-center">
            <v-sheet
              class="
                d-flex
                align-center
                justify-center
                flex-column
                text-center
                py-5 py-sm-8
                px-10 px-sm-16
                item-research
              "
            >
              <div
                class="
                  primary--text
                  text-body-2 text-sm-body-1
                  font-weight-medium
                  text-uppercase
                "
              >
                {{ research.before }}
              </div>
              <div
                class="
                  secondary--text
                  text-h4 text-sm-h3
                  font-weight-bold
                  text-uppercase
                "
              >
                {{ item.research }}
              </div>
              <div
                class="
                  primary--text
                  text-body-2 text-sm-body-1
                  font-weight-medium
                  text-uppercase
                "
              >
                {{ research.after }}
              </div>
            </v-sheet>
          </div>

          <div
            v-if="item.text || item.introduction"
            class="
              grey--text
              text--darken-2 text-subtitle-1
              font-weight-light
              mt-6 mt-md-8
              item-text
              ck-content
            "
          >
            <span
              class="font-secondary"
              v-html="item.text || item.introduction"
            ></span>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import TitleWidget from "../components/widgets/TitleWidget.vue";
import LoadingWidget from "../components/widgets/LoadingWidget.vue";
import DefaultImg from "../assets/img/default-img.png";

const _config = {
  mod: "about",
};

const _data = {
  title: "Sobre",
  research: {
    before: "Já são",
    after: "pesquisas realizadas",
  },
  loading: true,
};

export default {
  data: () => ({
    ..._data,
  }),
  computed: {
    item() {
      return this.$rest(_config.mod).item;
    },
    xsOnly() {
      return this.$vuetify.breakpoint.xsOnly;
    },
    smAndDown() {
      return this.$vuetify.breakpoint.smAndDown;
    },
  },
  methods: {
    onError(e) {
      e.target.src = DefaultImg;
    },
  },
  created() {
    this.$rest(_config.mod)
      .get({
        save: (state, data) => (state.item = data),
      })
      .finally(() => (this.loading = false));
  },
  components: {
    TitleWidget,
    LoadingWidget,
  },
};
</script>

<style lang="scss" scoped>
.item {
  &-text {
    line-height: 1.6;
  }

  &-img {
    display: block;
    -o-object-fit: cover;
    object-fit: cover;
  }

  &-research {
    border-radius: 10px;
    box-shadow: 0px 50px 70px -20px rgba(38, 20, 94, 0.15);
    margin-top: -77px;

    @media screen and (max-width: 599.9px) {
      margin-top: -60px;
    }
  }
}
</style>
